/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_RateInputs */

const en_cook_done_rate = /** @type {(inputs: Cook_Done_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How was it?`)
};

const de_cook_done_rate = /** @type {(inputs: Cook_Done_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie war’s?`)
};

/**
* | output |
* | --- |
* | "How was it?" |
*
* @param {Cook_Done_RateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_rate = /** @type {((inputs?: Cook_Done_RateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_RateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_rate(inputs)
	return en_cook_done_rate(inputs)
});